var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.currentTab=='majorCourse')?_c('myself-course'):(_vm.currentTab=='courseTask')?_c('course-task'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }